var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Képek")]),_vm._l((_vm.images),function(image){return _c('p',{key:image.id},[_c('img',{staticClass:"img-thumbnail",attrs:{"src":`data:image/jpg;base64,${image.picture}`,"alt":"Demo"}})])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }